import React from 'react';
import { Redirect, Route } from "react-router-dom";
import Loadable from "react-loadable";
import ProgressLoader from "../Loader/Loader";
import {
  getRolesArray,
  getToken,
  getTokenField,
  sessionRemoveData, tokenRolesField
} from "../../../services/session-storage-management/session-storage-management";

// Lista componenti da renderizzare (react-loadable permette di importare il chunk soltanto quando è effettivamente necessario)
const components = {
  login: Loadable({
    loader: () => {
      return import('../../../routes/authentication/authentication')
    },
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  loginOld: Loadable({
    loader: () => {
      return import('../../../routes/authentication/authentication-prod')
    },
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  loginSAML: Loadable({
    loader: () => {
      return import('../../../routes/authentication/authentication')
    },
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  materialSheetList: Loadable({
    loader: () => import('../../../routes/materialSheet/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  materialSheetDetail: Loadable({
    loader: () => import('../../../routes/materialSheet/materialSheetDetail/materialSheetDetail'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  sparePartsDetails: Loadable({
    loader: () => import('../../../routes/spareParts/SparePartsDetails/sparePartsDetails'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  ListaOrdineFornitore: Loadable({
    loader: () => import('../../../routes/ordineFornitore/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  NuovoOrdineFornitore: Loadable({
    loader: () => import('../../ordineFornitore/newOrderFornitore/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  NuovaEntrataMerci: Loadable({
    loader: () => import('../../ordineFornitore/newEntrataMerci/ind'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  spareParts: Loadable({
    loader: () => import('../../../routes/spareParts/indexSpare'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  FailureReport: Loadable({
    loader: () => import('../../../routes/failureReport/mainTableFR/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  DismissionReport: Loadable({
    loader: () => import('../../../routes/dismissionReport/mainTableDR/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  GiacenzaMagazzino: Loadable({
    loader: () => import('../../../routes/giacenzaMagazzino/giacenzaMagazzino'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  DashboardAdmin: Loadable({
    loader: () => import('../../../routes/dashboardAdmin/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  ConsoleMonitoring: Loadable({
    loader: () => import('../../../routes/consoleMonitoring/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  AnagraficaSeriali: Loadable({
    loader: () => import('../../../routes/giacenzeCespiti/index.js'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  PaliTralicci: Loadable({
    loader: () => import('../../../routes/paliTralicci/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  PaliTralicciInformazioni: Loadable({
    loader: () => import('../../../routes/paliTralicci/paliTralicciInformazioni/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  AdvancedSearch: Loadable({
    loader: () => import('../../anagrafiche/advancedSearch/advancedSearch'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  NavigationDeny: Loadable({
    loader: () => import('../NavigationDeny/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  SurveyDitta: Loadable({
    loader: () => import('../../../routes/survey/indexDitta'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  SurveyAdmin: Loadable({
    loader: () => import('../../../routes/surveyAdmin/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  BuoniPrelievoList: Loadable({
    loader: () => import('../../../routes/buoniPrelievo/index'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  BuoniPrelievoExport: Loadable({
    loader: () => import('../../../routes/buoniPrelievo/BuoniPrelievoExport'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  BuonoPrelievoDetail: Loadable({
    loader: () => import('../../../routes/buoniPrelievo/buonoPrelievoDetail/buonoPrelievoDetail'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  BuonoPrelievoMaterialDetail: Loadable({
    loader: () => import('../../../routes/buoniPrelievo/buonoPrelievoMaterialDetail/buonoPrelievoMaterialDetail'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),
  AppDownload: Loadable({
    loader: () => import('../../../routes/appDownload'),
    loading: () => {
      return <ProgressLoader />;
    },
  }),

}

/**
 *  Render Rotta di default --> login o mainPage
 * @param {Object} props - Oggetto contenente path - mainPage - token - loggedIn
 */

export const DefaultRoute = props => {
  let _token = isAuthenticated();
  let RenderComponent = components[props.importRoute];
  return <Route exact path={props.path} render={innerProps => _token ? (<Redirect to={props.mainPage} />) : (<RenderComponent {...innerProps} />)} />
}

/**
 *  Render Rotte private
 * @param {Object} component - componente da renderizzare se loggato
 * @param {Object} props - props con anche path definito
 */

export const PrivateRoute = (props) => {
  let _token = isAuthenticated();
  if (!_token) {
    sessionRemoveData('filters');
  }
  let RenderComponent = components[props.importRoute];
  return <Route path={props.path} render={innerProps => _token ? (<RenderComponent {...innerProps} />) : (<Redirect to="/login" />)} />
}

/**
 *  Check se sono autenticato
 */
export const isAuthenticated = () => {
  return getRolesArray(tokenRolesField);
}
